import { useState, useCallback } from "react";

export const useNotification = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((type, message, durationMs = 4000) => {
    setNotification({ type, message });
    setTimeout(() => {
      setNotification(null);
    }, durationMs);
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return {
    notification,
    showNotification,
    hideNotification,
  };
};
